import {
  Box,
  Checkbox,
  CheckboxGroup,
  Flex,
  FormControl,
  FormErrorMessage,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field } from "formik";

export const VoluntariadoAba = ({ children, props }) => {
  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Voluntariado
        </Text>
        {children}
      </Flex>

      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"O Serviço de Acolhimento possui voluntariado?"}
          mb={4}
        >
          O Serviço de Acolhimento possui voluntariado?
        </Text>

        <Field name="possuiVoluntariado">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.possuiVoluntariado &&
                form.touched.possuiVoluntariado
              }
              id="possuiAcessoMCA"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("possuiVoluntariado", value)
                }
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox value="S">Sim</Checkbox>

                  <Checkbox value="N">Não</Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.possuiVoluntariado}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
    </>
  );
};
